import React from "react";
import {Button, CheckBox, Column, Row, RowLR, Select, Spinner, Text, TextInput, TimeSpanInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {InfoButton, minuteInMS, Observer, TextPlus} from "web-vcore";
import {ControlInput} from "../../../@Shared/ControlInput.js";
import {EffectPointerInput} from "../../../@Shared/EffectPointerInput.js";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import {observer_mgl} from "mobx-graphlink";
import {SignalConfig} from "../../../../Server/DB/engineConfigs/@EngineConfig/@EC_Signals.js";
import {TriggerSet} from "../../../../Server/DB/engineConfigs/@TriggerSet.js";
import {ShowMessageBox} from "react-vmessagebox";
import {GetEntries} from "js-vextensions";
import {DreamFlawType, ImageFrameFlawType} from "../../../../Server/DB/engineConfigs/@EngineConfig/@EC_VR.js";
import {SettingUI} from "../../../../Server/DB/engineConfigs/@EngineConfig/@Shared/SettingUI.js";
import {FramePoolsUI, FramePoolUI} from "./VR/FramePoolUI.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.vr, (c, v)=>c.vr = v);
export type SharedProps_VRConfigUI = ReturnType<typeof GetSharedProps>;

const splitAt = 250;

export const VR_ConfigUI = observer_mgl((props: {} & EngineConfigPanels_SharedProps)=>{
	const {client, enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;

	return (
		<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
			<Row style={{fontSize: 18}}>
				<CheckBox text="VR" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
			</Row>

			{config.enabled &&
			<>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Headset on effect:</Text>
					<EffectPointerInput enabled={enabled} value={config.headsetOn_effect} onChange={val=>ChangeConfig(c=>c.headsetOn_effect = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Headset off effect:</Text>
					<EffectPointerInput enabled={enabled} value={config.headsetOff_effect} onChange={val=>ChangeConfig(c=>c.headsetOff_effect = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>Lie catch effect:</Text>
					<EffectPointerInput enabled={enabled} value={config.lieCatch_effect} onChange={val=>ChangeConfig(c=>c.lieCatch_effect = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<Text>False accuse effect:</Text>
					<EffectPointerInput enabled={enabled} value={config.falseAccuse_effect} onChange={val=>ChangeConfig(c=>c.falseAccuse_effect = val)}/>
				</RowLR>

				<Row mt={5} style={{fontWeight: "bold"}}>Dream panels</Row>
				<Column mt={5} ml={10}>
					<RowLR splitAt={splitAt - 10}>
						<Text>Dreams count:</Text>
						<Spinner enabled={enabled} min={0} step={1} value={config.dreams_count} onChange={val=>ChangeConfig(c=>c.dreams_count = val)}/>
					</RowLR>
					{/*<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Dreams (flawed):</Text>
						<Spinner enabled={enabled} min={0} step={1} value={config.dreams_flawed} onChange={val=>ChangeConfig(c=>c.dreams_flawed = val)}/>
					</RowLR>*/}
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Event count, min:</Text>
						<Spinner enabled={enabled} min={0} step={1} value={config.dreams_events_min} onChange={val=>ChangeConfig(c=>c.dreams_events_min = val)}/>
						<Text ml={5}>Max:</Text>
						<Spinner enabled={enabled} ml={5} min={0} step={1} value={config.dreams_events_max} onChange={val=>ChangeConfig(c=>c.dreams_events_max = val)}/>
					</RowLR>
					{/*<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Flaw type:</Text>
						<Select enabled={enabled} options={GetEntries(DreamFlawType, "ui")} value={config.dreams_flawType} onChange={val=>ChangeConfig(c=>c.dreams_flawType = val)}/>
					</RowLR>*/}
				</Column>

				<Row mt={5} style={{fontWeight: "bold"}}>Image frames</Row>
				<Column mt={5} ml={10}>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Size:</Text>
						<Spinner enabled={enabled} min={0} step={.1} value={config.frames_size} onChange={val=>ChangeConfig(c=>c.frames_size = val)}/>
						<Text>m</Text>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Zoom-time per frame:</Text>
						<Spinner enabled={enabled} min={0} step={.1} value={config.frames_duration} onChange={val=>ChangeConfig(c=>c.frames_duration = val)}/>
						<Text>s</Text>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<TextPlus info="To disable flickering, set either duration to 0.">Flicker, on-duration:</TextPlus>
						<Spinner enabled={enabled} min={0} step={1} value={config.frames_flickerOnDuration} onChange={val=>ChangeConfig(c=>c.frames_flickerOnDuration = val)}/>
						<Text>ms</Text>
						<Text ml={5}>Off-duration:</Text>
						<Spinner enabled={enabled} ml={5} min={0} step={1} value={config.frames_flickerOffDuration} onChange={val=>ChangeConfig(c=>c.frames_flickerOffDuration = val)}/>
						<Text>ms</Text>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Time-credit target:</Text>
						<TimeSpanInput enabled={enabled} largeUnit="hour" smallUnit="minute" value={config.frames_timeCreditTarget / minuteInMS} onChange={val=>ChangeConfig(c=>c.frames_timeCreditTarget = val * minuteInMS)}/>
						<Text ml={5}>Marker every:</Text>
						<TimeSpanInput enabled={enabled} ml={5} largeUnit="hour" smallUnit="minute" value={config.frames_timeCreditMarkerInterval / minuteInMS} onChange={val=>ChangeConfig(c=>c.frames_timeCreditMarkerInterval = val * minuteInMS)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Time-credit limit per frame:</Text>
						<Spinner enabled={enabled} min={0} value={config.frames_timeCreditLimitPerFrame} onChange={val=>ChangeConfig(c=>c.frames_timeCreditLimitPerFrame = val)}/>
						<Text>s</Text>
					</RowLR>
					{/*<RowLR mt={5} splitAt={splitAt - 10}>
						<Text mr={5}>Voice, tag:</Text>
						<TextInput enabled={enabled} style={{width: 80}} value={config.frames_voice_soundTag} onChange={val=>ChangeConfig(c=>c.frames_voice_soundTag = val)}/>
						<Text ml={5} mr={5}>Vol. mult.:</Text>
						<SpinnerForPercent min={0} enabled={enabled} value={config.frames_voice_volumeMultiplier} onChange={val=>ChangeConfig(c=>c.frames_voice_volumeMultiplier = val)}/>
					</RowLR>*/}
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text mr={5}>Voice, volume multiplier:</Text>
						<SpinnerForPercent min={0} max={999} enabled={enabled} value={config.frames_voice_volumeMultiplier} onChange={val=>ChangeConfig(c=>c.frames_voice_volumeMultiplier = val)}/>
						<Text ml={5} mr={5}>Speed mult.:</Text>
						<SpinnerForPercent ml={5} min={0} max={999} enabled={enabled} value={config.frames_voice_speedMultiplier} onChange={val=>ChangeConfig(c=>c.frames_voice_speedMultiplier = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Image folder:</Text>
						<TextInput enabled={enabled} value={config.frames_imageFolder} onChange={val=>ChangeConfig(c=>c.frames_imageFolder = val)}/>
						<InfoButton ml={5} text={`
							The folder containing the frame images. (example: "Pictures/LF/Frames/")
							The actual images are expected underneath it, eg. "Pictures/LF/Frames/EP1/Character1/00-10-05.png".
							Note: For now at least, the image-folder MUST either be "Pictures/LF/", or a subfolder of it. (to avoid perf and/or privacy issues, this is hard-coded)
						`.AsMultiline(0)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Audio folder:</Text>
						<TextInput enabled={enabled} value={config.frames_audioFolder} onChange={val=>ChangeConfig(c=>c.frames_audioFolder = val)}/>
						<InfoButton ml={5} text={`
							The folder containing the audio-files for the videos that the frame-images were sourced from. (example: "Alarms/LF/FramesAudio/")
							The actual audio-files are expected underneath it, eg. "Alarms/LF/FramesAudio/EP1.ogg". [this would work with the example path seen in notes for image-folder]
							Note: For now at least, the audio-folder MUST either be "Alarms/LF/", or a subfolder of it. (to avoid perf and/or privacy issues, this is hard-coded)
						`.AsMultiline(0)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Video folder:</Text>
						<TextInput enabled={enabled} value={config.frames_videoFolder} onChange={val=>ChangeConfig(c=>c.frames_videoFolder = val)}/>
						<InfoButton ml={5} text={`
							The folder containing the video-files for the videos that the frame-images were sourced from. (example: "Movies/LF/FramesVideo/")
							The actual video-files are expected underneath it, eg. "Movies/LF/FramesVideo/EP1.mp4". [this would work with the example path seen in notes for image-folder]
							Note: For now at least, the video-folder MUST either be "Movies/LF/", or a subfolder of it. (to avoid perf and/or privacy issues, this is hard-coded)
						`.AsMultiline(0)}/>
					</RowLR>
					<FramePoolsUI {...sharedProps}/>
				</Column>

				<Row mt={5}>
					<CheckBox enabled={enabled} text="Use flaw-finding as solver" value={config.solver_enabled} onChange={val=>ChangeConfig(c=>c.solver_enabled = val)}/>
				</Row>
				{config.solver_enabled &&
				<Column mt={5} ml={10}>
					<RowLR splitAt={splitAt - 10}>
						<Text>Min flaw-finds:</Text>
						<Spinner enabled={enabled} min={0} step={1} value={config.solver_minFlawFinds} onChange={val=>ChangeConfig(c=>c.solver_minFlawFinds = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Mark progress before completion:</Text>
						<CheckBox enabled={enabled} value={config.solver_markProgressBeforeCompletion} onChange={val=>ChangeConfig(c=>c.solver_markProgressBeforeCompletion = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<Text>Max time for progress:</Text>
						<TimeSpanInput enabled={enabled} value={config.solver_maxTimeForProgress} onChange={val=>ChangeConfig(c=>c.solver_maxTimeForProgress = val)}/>
					</RowLR>
				</Column>}
			</>}
		</Column>
	);
});